import * as React from 'react'
import { ColumnValue, StatusOption } from '../types'
import { getContrastColor } from '../../project_groups_columns/helpers'

interface StatusCellProps {
  value: ColumnValue
  statusOptions: StatusOption[]
}

export function StatusCell({ value, statusOptions }: StatusCellProps): React.ReactNode {
  if (value == null || value === '' || Array.isArray(value)) {
    return null
  }

  const statusValue = String(value)
  const option = statusOptions.find((opt) => opt.value === statusValue)
  const bgColor = option?.color || '#e9ecef'
  const textColor = getContrastColor(bgColor)

  return (
    <span
      className="badge mr-1 mb-1"
      style={{
        backgroundColor: bgColor,
        color: textColor,
      }}
    >
      {option?.label ?? statusValue}
    </span>
  )
}
